import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Table, Td, Row } from '@layout/DashboardTable';
import { Container } from '@layout/PhoneNumbersPage';
import { PageTemplate } from '@templates';
import messages from './messages';

export const PhoneNumbersPage = ({ countries, isSidebarVisible }) => (
  <PageTemplate
    title={<FormattedMessage {...messages.title} />}
    isSidebarVisible={isSidebarVisible}
  >
    <Container>
      <Table>
        <thead>
          <Row>
            <Td primary>
              <FormattedMessage {...messages.countries} />
            </Td>
            <Td primary>
              <FormattedMessage {...messages.numbers} />
            </Td>
            <Td primary>
              <FormattedMessage {...messages.tollFree} />
            </Td>
          </Row>
        </thead>
        <tbody>
          {countries.map(({ id, country, number, isTollFree }) => (
            <Row background key={id}>
              <Td>{country}</Td>
              <Td>
                <a href={`tel:${number}`}>{number}</a>
              </Td>
              <Td>{isTollFree ? 'Yes' : 'No'}</Td>
            </Row>
          ))}
        </tbody>
      </Table>
    </Container>
  </PageTemplate>
);

PhoneNumbersPage.propTypes = {
  countries: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      country: PropTypes.string.isRequired,
      number: PropTypes.string.isRequired,
    }),
  ),
};



// WEBPACK FOOTER //
// ./components/pages/PhoneNumbersPage/PhoneNumbersPage.js